import { TYPES } from './types';

export function Collection(type) {
    type[TYPES.COLLECTION] = true;
    type.prototype[TYPES.COLLECTION] = true;

    return type;
}
